import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { NOINDEX_PRIVATE_SEO } from "../../constants/siteSeo";
import { usePageSeo } from "../../hooks/usePageSeo";
import { useAuth } from "../../context/AuthContext";
import { SITE_DASHBOARD_PATH } from "../../constants/siteNavRoutes";
import AuthPageWalletSignIn from "./AuthPageWalletSignIn";
import "./auth-pages.css";

export default function SignupPage() {
  usePageSeo({
    ...NOINDEX_PRIVATE_SEO,
    title: "Create account | Treydora",
    description: "Create a free Treydora account for dashboard and My Library access.",
  });

  const { register } = useAuth();
  const navigate = useNavigate();
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }
    const trimmedEmail = email.trim();
    const dn = displayName.trim();
    const fallbackUsername = trimmedEmail.split("@")[0] || "treydora-user";
    setBusy(true);
    try {
      await register({
        username: dn || fallbackUsername,
        email: trimmedEmail,
        password,
      });
      navigate(SITE_DASHBOARD_PATH, { replace: true });
    } catch (err) {
      setErrorMessage(err?.message || "Unable to create account right now.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="td-auth-page">
      <div className="td-auth-page__card">
        <p className="td-auth-page__brand">Treydora</p>
        <h1 className="td-auth-page__title">Create account</h1>
        <p className="td-auth-page__lead">
          One Treydora account for the storefront, library, and dashboard. You can link a wallet after
          registration from the header.
        </p>

        <form className="td-auth-page__form" onSubmit={onSubmit}>
          <input
            type="text"
            autoComplete="nickname"
            placeholder="Display name (optional)"
            value={displayName}
            onChange={(ev) => setDisplayName(ev.target.value)}
          />
          <input
            type="email"
            autoComplete="email"
            placeholder="Email"
            value={email}
            onChange={(ev) => setEmail(ev.target.value)}
            required
          />
          <input
            type="password"
            autoComplete="new-password"
            placeholder="Password"
            value={password}
            onChange={(ev) => setPassword(ev.target.value)}
            required
            minLength={6}
          />
          <input
            type="password"
            autoComplete="new-password"
            placeholder="Confirm password"
            value={confirmPassword}
            onChange={(ev) => setConfirmPassword(ev.target.value)}
            required
            minLength={6}
          />
          <div className="td-auth-page__actions">
            <button type="submit" className="oshar-btn-gold" style={{ width: "100%" }} disabled={busy}>
              {busy ? "Creating…" : "Create account"}
            </button>
          </div>
        </form>

        {errorMessage ? <p className="td-auth-page__err">{errorMessage}</p> : null}

        <div className="td-auth-page__links">
          <Link to="/login">Already have an account? Sign in</Link>
        </div>

        <div className="td-auth-page__divider">or</div>
        <AuthPageWalletSignIn />
      </div>
    </div>
  );
}
